<template>
  <div>
    <search-list :projectList="projectList"
                 :statusList="allStatusList"
                 :sourceList="sourceList"
                 :channelList="channelList"
                 :gradeList="gradeList"
                 :isLookList = "isLookList"
                 :callStatus="callStatus"
                 :loseReasonList = "loseReasonList"
                 @findData="findData"
                 :enumList="enumList"
                 style="padding: 0"
    ></search-list>
    <div class="">
    <table-list
      title=""
      :defaultColumns="defaultColumns"
      :columns="columns"
      :current="current"
      :data="tableList"
      :total="total"
      :loading="loading"
      @change-page="changPage"
      @on-selection-change="selectItem"
    >
      <Button type="primary" class="btn" @click="createBusiness"
              v-p="{api:'business/createBusiness'}"
      >新建商机</Button>
      <Button type="primary" class="btn" @click="assignBusiness"
              v-p="{api:'business/allocateBusiness'}"
      >分配商机</Button>
      <Button type="primary" class="btn" @click="exportBusiness" :loading = "btnLoading"
              v-p="{api:'business/downloadBusinessList'}"
      >导出商机</Button>
    </table-list>
    </div>
    <create-business-modal
      :enumList="enumList"
      :projectList="projectList"
      :clientTypeList="clientTypeList"
      :projectFid = "projectFid"
      :statusList = "statusList"
      :channelList = "channelList"
      :budgetRangeList="budgetRangeList"
      :commutingModeList="commutingModeList"
      :intentionAreaList="intentionAreaList"
      :houseTypeList="houseTypeList"
      :liveNumberList="liveNumberList"
      :placeList="placeList"
      :shortRentDesList="shortRentDesList"
      :rentTimeList="rentTimeList"
      :n = "createKey"
      :gradeList="gradeList"
      @refresh="refreshData(searchData)"
    >
    </create-business-modal>
    <assign-business-modal :selectedBusiness="selectedBusiness" :projectFid = "assginProjectFid" :projectName = "projectName" :count = "businessCount" :n="assignKey" @refresh="refreshData(searchData)"></assign-business-modal>
    <read-or-handle-modal
      :uid="uid"
      :n="readOrHandleKey"
      :zoFid="zoFid"
      :clientTypeList="clientTypeList"
      :businessFid = "businessFid"
      :projectFid="detailProjectFid"
      :statusList = "handleStatusList"
      :budgetRangeList="budgetRangeList"
      :commutingModeList="commutingModeList"
      :intentionAreaList="intentionAreaList"
      :houseTypeList="houseTypeList"
      :liveNumberList="liveNumberList"
      :placeList="placeList"
      :shortRentDesList="shortRentDesList"
      :rentTimeList="rentTimeList"
      @showHistory="showHistory"
      @refresh="refreshData(searchData)"
      :isRead="isRead"
      :enum-list="enumList"
      :gradeList="gradeList"
    >
    </read-or-handle-modal>

    <add-confirm-order-form   :n = "addConfirmOrderKey" :serviceRate="serviceRate" :zoFid="zoFid" :zoName="zoName" :businessFid = "businessFid" :projectFid="projectFid" :projectName="projectName" :customerName="customerName" :customerPhone="customerPhone" @refresh="refreshData(searchData)"></add-confirm-order-form>
    <modify-confirm-order-form   :n = "modifyConfirmOrderKey"  :serviceRate="serviceRate" :businessFid = "businessFid"  @refresh="refreshData(searchData)"></modify-confirm-order-form>
    <check-personas
		:uid="uid"
    :n="checkPersonasKey"
    ></check-personas>
    <update-personas
      :n="updatePersonasKey"
			:uid="uid"
			:projectFid="projectFid"
    ></update-personas>
   <change-zo :n="cN" :data="changItem" @done="refreshData(searchData)"></change-zo>
    <!-- <history-modal :n="showHistoryKey"></history-modal> -->
  </div>
</template>

<script type="text/ecmascript-6">

import { getSelectedData, getList, getDetail, getHistory, handleBusiness, allowHandleBusiness, downloadBusinessList, checkBusinessCount,getIsShowRecord ,getBusinessEnums } from 'api/business'
import { getProjectHouseType,getProjects } from 'api/common'
import { deepClone,formatDateTimeExceptSecond,formatDateTime  } from '@/utils/format'
import { getBaseUrl } from "@/utils/public";
import SearchList from './components/SearchList'
import TableList from 'components/FilterTableList/index';
import CreateBusinessModal from './components/CreateBusinessModal';
import AssignBusinessModal from './components/AssignBusinessModal';
import ReadOrHandleModal from './components/ReadOrHandle';
// import MsgTip from './components/MsgTip';
import AddConfirmOrderForm from '../../confirmOrderManage/components/AddConfirmOrderForm';
import ModifyConfirmOrderForm from '../../confirmOrderManage/components/ModifyConfirmOrderForm';
import {getBaseInfoByProjectId} from "../../../api/project";
import ChangeZo from './components/ChangeZo'
import { mapGetters } from 'vuex';
import UpdatePersonas from '../infoManage/components/UpdatePersonas'
import CheckPersonas from '../infoManage/components/CheckPersonas'

export default {
  name:'readbusiness',
  created() {
    this.getAllSelect()
    if(this.$route.params.customerInfo){
      this.searchData.customerInfo = this.$route.params.customerInfo
    }
    getIsShowRecord().then( res=> {
      this.isEnableRecord = res.data
      if(this.isEnableRecord) {
        this.columns = this.columnsRecord
      }else {
        this.columns = this.columnsUNRecord
      }
      this.initData()
    })


  },
  computed:{
    ...mapGetters(['empCode'])


  },
  components: {
    UpdatePersonas,
    CheckPersonas,
    SearchList,
    TableList,
    CreateBusinessModal,
    AssignBusinessModal,
    ReadOrHandleModal,
    AddConfirmOrderForm,
    ModifyConfirmOrderForm,
    // MsgTip,
    ChangeZo
    // HistoryModal
  },
  data() {
    return {
      callStatus:[],
      uid:'',
      projectFid:'',
      updatePersonasKey:0,
      checkPersonasKey:0,
      changItem:null,
      cN:0,
      baseUrl:getBaseUrl(),
      phoneStr:'', // 1小时内约看商机的电话
      selectedData:null,
      projectList:[],
      allStatusList:[],
      statusList:[],
      handleStatusList: [],
      sourceList:[],
      channelList:[],
      gradeList: [],
      clientTypeList:[],
      // houseTypeList:[],
      isLookList:[],
      loseReasonList:[],
      projectName:'',
      assginProjectFid:'',
      detailProjectFid:'',
      businessFid:'',
      zoFid:'',
      zoName:'',
      customerName:'',
      customerPhone:'',
      businessCount:0,
      newestFollowTime:'',
      businessBelongDate:'',
      current:1,
      total:0,
      searchData: {
        callStatus:'',
        projectFid: '',
        zoFid: '',
        businessStatus: '',
        businessFromPlatform:'',
        businessFromChannel:[],
        businessEndHandleTimeF:'',
        businessEndHandleTimeT:'',
        createTimeFrom:'',
        createTimeTo:'',
        customerInfo:'',
        isLook:'',
        page: 1,
        limit: 10
      },
      loading:true,
      btnLoading:false,
      createKey:0,
      assignKey:0,
      readOrHandleKey:0,
      isRead:false,
      showHistoryKey:0,
      addConfirmOrderKey:0,
      modifyConfirmOrderKey:0,
      selectedBusiness:[],
      columns:[],
      projectCooperationModel:0,
      serviceRate:0,
      defaultColumns:['handleStatus','grade','projectName','customerName','customerPhone','zoName','createTime',
        'newestFollowTime','lastHandleRecord', 'keyTip','callStatusName','businessFid','customerTypeName','businessFromPlatform',
        'businessFromChannel','action'],
      columnsUNRecord:[
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },

        {
          title:' '
        },
        {
          title: '商机状态',
          key: 'handleStatus',
          width:90,
          align: 'center',
          render: (h,params) => {
            return h('div',{
              'class': {
                'error-color': params.row.handleStatus == 0,
                'warning-color ': params.row.handleStatus == 2 || params.row.handleStatus == 7,
                'success-color':params.row.handleStatus == 1,
                'content-color':params.row.handleStatus == 3,
                'disable-color':params.row.handleStatus == 4 || params.row.handleStatus == 5 || params.row.handleStatus == 6,
              },
            },this.getStatusStr(params.row.handleStatus))
          }
        },
        {
          title:' '
        },
        {
          title: '商机等级',
          key: 'grade',
          align: 'center',
          width:90
        },
        {
          title:' '
        },
        {
          title: '项目名称',
          key: 'projectName',
          align: 'center',
          width:160
        },
        {
          title:' '
        },
        {
          title: '客户姓名',
          key: 'customerName',
          width:100,
          align: 'center'
        },
        {
          title:' '
        },
        {
          title: '电话',
          key: 'customerPhone',
          align: 'center',
          width:120,
          render: (h,params) => {
            return h('div',{
              'class': {
                'error-color': params.row.isRepeat == 1,
              },
            },this.getRepeat(params.row.isRepeat, params.row.customerPhone))
          }
        },
        {
          title:' '
        },
        {
          title: '管家',
          key: 'zoName',
          width:90,
          align: 'center'
        },
        {
          title:' '
        },

        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '截止处理时间',
          key: 'endHandleTime',
          align: 'center',
          width:180,
          render: (h,params) => {
            return h('div',formatDateTime(params.row.endHandleTime, true))
          }
        },
        {
          title:' '
        },
        {
          title: '是否看过直播看房',
          key: 'isSeen',
          align: 'center',
          width:160,
          render: (h,params) => {
            if(params.row.isSeen===1){
              return h('span',{},'是')
            } else if(params.row.isSeen===0){
              return h('span',{},'否')
            } else{
              return h('span',{},' ')
            }
          }
        },
        {
          title:' '
        },
        {
          title: '首次跟进时间',
          key: 'firstFollowTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '最新跟进时间',
          key: 'newestFollowTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '最新跟进内容',
          key: 'lastHandleRecord',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '关键信息提示',
          key: 'keyTip',
          align: 'center',
          width:200,
          //render:(h,params)
        },
        {
          title:' '
        },
        {
          title: '通话状态',
          key: 'callStatusName',
          align: 'center',
          width:180,
          render: (h,params) => {
            return h('div',{
              'class': {
                'error-color': params.row.callStatus !=='disaccept',
              },
            },params.row['callStatusName'])
          }
        },
        {
          title:' '
        },
        {
          title: '客户类型',
          key: 'customerTypeName',
          width:120,
          align: 'center'

        },
        {
          title:' '
        },
        {
          title: '来源平台',
          key: 'businessFromPlatform',
          align: 'center',
          width:100,
          render: (h,params) => {
            return h('div',this.getPlatStr(params.row.businessFromPlatform))
          }
        },
        {
          title:' '
        },
        {
          title: '来源渠道',
          key: 'businessFromChannel',
          width:100,
          align: 'center',
          render: (h,params) => {
            return h('div',this.getChannelStr(params.row.businessFromChannel))
          }
        },
        {
          title:' '
        },
        {
          title: '渠道人信息',
          key: 'superZoBusinessChannelInfo',
          width:200,
          align: 'center',
          render: (h,params) => {
            if(params.row.channelCode){
              return h('div',params.row.channelPhone + '-' + params.row.channelName + params.row.channelCode)
            }
          }
        },
        {
          title:' '
        },
        {
          title: '操作',
          key: 'action',
          width:150,
          fixed:'right',
          align: 'center',
          render: (h,params)=>{
            return h('div',[
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/getDetail'
                    }
                  }
                ],
                style: {
                  marginRight: '5px'
                },
                on:{
                  click: () => {
                    this.isRead = true
                    this.readOrHandleKey++;
                    this.businessFid = params.row.businessFid
                    this.detailProjectFid = params.row.projectFid
                    this.uid = params.row.customerUid;
                  }
                }
              },'跟进记录'),
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/saveBusinessHandle'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.handleStatus==4 || params.row.handleStatus == 5 || params.row.handleStatus ==6 ? 'none' :'inline-block'
                },
                on:{
                  click: () => {
                    allowHandleBusiness(params.row.businessFid).then( res => {
                      if(res.data==='true') {
                        this.handleStatusList = []
                        this.statusList.forEach(item => {
                          this.handleStatusList.push(item)
                        })
                        if(params.row.handleStatus === 3 || params.row.handleStatus === 7) {
                          let index = this.handleStatusList.findIndex(item => {
                            return item.value == 1
                          })
                          if(index > -1) {
                            this.handleStatusList.splice(index,1)
                          }
                          index = this.handleStatusList.findIndex(item => {
                            return item.value == 2
                          })
                          if(index > -1) {
                            this.handleStatusList.splice(index,1)
                          }
                        }
                        if( params.row.handleStatus === 7) {
                          const index = this.handleStatusList.findIndex(item => {
                            return item.value == 7
                          })
                          if(index > -1) {
                            this.handleStatusList.splice(index,1)
                          }
                        }
                        this.isRead = false
                        this.readOrHandleKey++;
                        this.businessFid = params.row.businessFid
                        this.detailProjectFid = params.row.projectFid
                        this.zoFid = params.row.zoFid
                        this.uid = params.row.customerUid;
                      }else {
                        this.$Message.error('您没有修改该条商机的权限')
                      }
                    })

                  }
                }
              },'处理'),h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/saveBusinessHandle'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: this.projectCooperationModel ==3 && params.row.haveConfirmOrder ==2 ? 'inline-block' :'none'
                },
                on:{
                  click: () => {
                    this.addConfirmOrderKey++;
                    this.businessFid = params.row.businessFid
                    this.projectFid = params.row.projectFid
                    this.projectName = params.row.projectName
                    this.zoFid = params.row.zoFid
                    this.zoName = params.row.zoName
                    this.customerPhone=params.row.customerPhone
                    this.customerName=params.row.customerName
                  }
                }
              },'录入确认单'),h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/saveBusinessHandle'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: this.projectCooperationModel ==3 && params.row.haveConfirmOrder ==1 ? 'inline-block' :'none'
                },
                on:{
                  click: () => {
                    this.modifyConfirmOrderKey++;
                    this.businessFid = params.row.businessFid
                  }
                }
              },'修改确认单'),
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/changeTakeLookZo'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display:( params.row['zoFid']===this.empCode && [1,2].indexOf(params.row['handleStatus'])!==-1) ? 'inline-block' :'none'
                },
                on:{
                  click: () => {
                    this.changItem=params.row
                    this.cN++

                  }
                }
              },'转交'),
              h('a',{
                style: {
                  marginRight: '5px',
                  display:params.row.customerUid ? 'inline-block' :'none'
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/updateCustomer'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.projectFid = params.row.projectFid;
                    this.uid = params.row.customerUid;
                    this.updatePersonasKey++
                  }
                }
              },'更新画像'),h('a',{
                style: {
                  marginRight: '5px',
                  display:params.row.customerUid ? 'inline-block' :'none'
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/getCustomerPortrait'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.uid = params.row.customerUid;
                    this.checkPersonasKey++;
                  }
                }
              },'查看画像')])
          }
        },
      ],
      columnsRecord:[
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },

        {
          title:' '
        },
        {
          title: '商机状态',
          key: 'handleStatus',
          width:90,
          align: 'center',
          render: (h,params) => {
            return h('div',{
              'class': {
                'error-color': params.row.handleStatus == 0,
                'warning-color ': params.row.handleStatus == 2 || params.row.handleStatus == 7,
                'success-color':params.row.handleStatus == 1,
                'content-color':params.row.handleStatus == 3,
                'disable-color':params.row.handleStatus == 4 || params.row.handleStatus == 5 || params.row.handleStatus == 6,
              },
            },this.getStatusStr(params.row.handleStatus))
          }
        },
        {
          title:' '
        },
        {
          title:' '
        },
        {
          title: '商机等级',
          key: 'grade',
          align: 'center',
          width:90
        },
        {
          title: '项目名称',
          key: 'projectName',
          align: 'center',
          width:160

        },
        {
          title:' '
        },
        {
          title: '客户姓名',
          key: 'customerName',
          width:100,
          align: 'center'
        },
        {
          title:' '
        },
        {
          title: '电话',
          key: 'customerPhone',
          align: 'center',
          width:120,
          render: (h,params) => {
            return h('div',{
              'class': {
                'error-color': params.row.isRepeat == 1,
              },
            },this.getRepeat(params.row.isRepeat, params.row.customerPhone))
          }
        },
        {
          title:' '
        },
        {
          title: '管家',
          key: 'zoName',
          width:90,
          align: 'center'
        },
        {
          title:' '
        },

        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '截止处理时间',
          key: 'endHandleTime',
          align: 'center',
          width:180,
          render: (h,params) => {
            return h('div',formatDateTime(params.row.endHandleTime, true))
          }
        },
        {
          title:' '
        },
        {
          title: '是否看过直播看房',
          key: 'isSeen',
          align: 'center',
          width:160,
          render: (h,params) => {
            if(params.row.isSeen===1){
              return h('span',{},'是')
            } else if(params.row.isSeen===0){
              return h('span',{},'否')
            } else{
              return h('span',{},' ')
            }
          }
        },
        {
          title:' '
        },
        {
          title: '首次跟进时间',
          key: 'firstFollowTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '最新跟进时间',
          key: 'newestFollowTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '最新跟进内容',
          key: 'lastHandleRecord',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '关键信息提示',
          key: 'keyTip',
          align: 'center',
          width:200,
          //render:(h,params)
        },
        {
          title:' '
        },
        {
          title: '通话状态',
          key: 'callStatusName',
          align: 'center',
          width:180,
          render: (h,params) => {
            return h('div',{
              'class': {
                'error-color': params.row.callStatus !=='disaccept',
              },
            },params.row['callStatusName'])
          }
        },
        {
          title:' '
        },
        {
          title: '通话录音',
          key: 'businessFid',
          width:250,
          align: 'center',
          render:(h,params)=>{
            const actions = [];
            const audio= h('audio',{
              attrs:{
                src:params.row.record,
                controls:'controls',
              },
              style:{
                height:'40px',
                width:'100%',
                verticalAlign:'middle'

              }
            },'不支持');
            if(params.row.record) {
              actions.push(audio)
            }
            return h('div', {}, actions)
          }

        },
        {
          title:' '
        },
        {
          title: '客户类型',
          key: 'customerTypeName',
          width:120,
          align: 'center'

        },
        {
          title:' '
        },
        {
          title: '来源平台',
          key: 'businessFromPlatform',
          align: 'center',
          width:100,
          render: (h,params) => {
            return h('div',this.getPlatStr(params.row.businessFromPlatform))
          }
        },
        {
          title:' '
        },
        {
          title: '来源渠道',
          key: 'businessFromChannel',
          width:100,
          align: 'center',
          render: (h,params) => {
            return h('div',this.getChannelStr(params.row.businessFromChannel))
          }
        },
        {
          title:' '
        },
        {
          title: '渠道人信息',
          key: 'superZoBusinessChannelInfo',
          width:200,
          align: 'center',
          render: (h,params) => {
            if(params.row.channelCode){
              return h('div',params.row.channelPhone + '-' + params.row.channelName + params.row.channelCode)
            }
          }
        },
        {
          title:' '
        },
        {
          title: '操作',
          key: 'action',
          width:250,
          fixed:'right',
          align: 'center',
          render: (h,params)=>{
            return h('div',[h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'business/getDetail'
                  }
                }
              ],
              style: {
                marginRight: '5px'
              },
              on:{
                click: () => {
                  this.isRead = true
                  this.readOrHandleKey++;
                  this.businessFid = params.row.businessFid
                  this.detailProjectFid = params.row.projectFid
                }
              }
            },'跟进记录'),h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'business/saveBusinessHandle'
                  }
                }
              ],
              style: {
                marginRight: '5px',
                display: params.row.handleStatus==4 || params.row.handleStatus == 5 || params.row.handleStatus ==6 ? 'none' :'inline-block'
              },
              on:{
                click: () => {
                  allowHandleBusiness(params.row.businessFid).then( res => {
                    if(res.data==='true') {
                      this.uid=params.row.customerUid
                      this.handleStatusList = []
                      this.statusList.forEach(item => {
                        this.handleStatusList.push(item)
                      })
                      if(params.row.handleStatus === 3 || params.row.handleStatus === 7) {
                        let index = this.handleStatusList.findIndex(item => {
                          return item.value == 1
                        })
                        if(index > -1) {
                          this.handleStatusList.splice(index,1)
                        }
                        index = this.handleStatusList.findIndex(item => {
                          return item.value == 2
                        })
                        if(index > -1) {
                          this.handleStatusList.splice(index,1)
                        }
                      }
                      if( params.row.handleStatus === 7) {
                        const index = this.handleStatusList.findIndex(item => {
                          return item.value == 7
                        })
                        if(index > -1) {
                          this.handleStatusList.splice(index,1)
                        }
                      }
                      this.uid=params.row.customerUid
                      this.isRead = false
                      this.readOrHandleKey++;
                      this.businessFid = params.row.businessFid
                      this.detailProjectFid = params.row.projectFid
                      this.zoFid = params.row.zoFid
                    }else {
                      this.$Message.error('您没有修改该条商机的权限')
                    }
                  })

                }
              }
            },'处理'),h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'contractConfirmOrder/addOrUpdate'
                  }
                }
              ],
              style: {
                marginRight: '5px',
                display: this.projectCooperationModel ==3 && params.row.haveConfirmOrder !=1? 'inline-block' :'none'
              },
              on:{
                click: () => {
                  this.addConfirmOrderKey++;
                  this.businessFid = params.row.businessFid
                  this.projectFid = params.row.projectFid
                  this.projectName = params.row.projectName
                  this.zoFid = params.row.zoFid
                  this.zoName = params.row.zoName
                  this.customerPhone=params.row.customerPhone
                  this.customerName=params.row.customerName
                }
              }
            },'录入确认单'),h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'contractConfirmOrder/addOrUpdate'
                  }
                }
              ],
              style: {
                marginRight: '5px',
                display: this.projectCooperationModel ==3 && params.row.haveConfirmOrder ==1 ? 'inline-block' :'none'
              },
              on:{
                click: () => {
                  this.modifyConfirmOrderKey++;
                  this.businessFid = params.row.businessFid
                }
              }
            },'修改确认单'),
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/changeTakeLookZo'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display:( params.row['zoFid']===this.empCode && [1,2].indexOf(params.row['handleStatus'])!==-1) ? 'inline-block' :'none'
                },
                on:{
                  click: () => {
                    this.changItem=params.row
                    this.cN++

                  }
                }
              },'转交'),
              h('a',{
                style: {
                  marginRight: '5px',
                  display:params.row.customerUid ? 'inline-block' :'none'

                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/updateCustomer'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.projectFid = params.row.projectFid;
                    this.uid = params.row.customerUid;
                    this.updatePersonasKey++
                  }
                }
              },'更新画像'),h('a',{
                style: {
                  marginRight: '5px',
                  display:params.row.customerUid ? 'inline-block' :'none'

                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/getCustomerPortrait'
                    }
                  }
                ],
                on:{
                  click:()=>{
                    this.uid = params.row.customerUid;
                    this.checkPersonasKey++;
                  }
                }
              },'查看画像')
            ])
          }
        },
      ],
      tableList:[],
      isEnableRecord:false,
      budgetRangeList:[],
      commutingModeList:[],
      intentionAreaList:[],
      houseTypeList:[],
      liveNumberList:[],
      placeList:[],
      shortRentDesList:[],
      rentTimeList:[],
      enumList:null,
    }
  },
  methods: {
    getAllSelect(){
      getBusinessEnums().
      then( res => {
        this.enumList=res.data


        this.budgetRangeList = res.data.budgetRange;
        this.commutingModeList = res.data.commutingMode;
        this.intentionAreaList = res.data.intentionArea;
        this.houseTypeList = res.data.houseType;
        const liveNumberList = res.data.liveNumber;
        for(let i = 1 ; i <= liveNumberList; i++){
          this.liveNumberList.push(i)
        }
        this.placeList = res.data.place;
        this.shortRentDesList = res.data.shortRentDes;
        this.rentTimeList = res.data.rentTime;
      })
    },
    createBusiness(){

      this.createKey++
    },

    assignBusiness() {
      if(this.selectedBusiness.length === 0) {
        this.$Message.error('请选择商机');
      } else {
        const projectFid = this.selectedBusiness[0].projectFid
        const temArr = this.selectedBusiness.filter( (item,i) => {
          return item.projectFid !== projectFid
        })
        if(temArr.length > 0) {
          this.$Message.error('请选择同一项目下的商机');
        } else {
          this.assginProjectFid = projectFid
          this.projectName = this.selectedBusiness[0].projectName
          this.businessCount = this.selectedBusiness.length
          this.assignKey++
        }
      }
    },
    changPage(n){
      this.loading = true;
      this.current = n;
      this.searchData.page = n
      this.initTableList()
    },
    exportBusiness(){
      const data = {}
      for (const key in this.searchData) {
        if(key==='page' || key==='limit') continue
        data[key] = this.searchData[key]
      }
      checkBusinessCount(data).then( res => {
        if(res.data > 10000){
          this.$Modal.info({
            title: '导出商机',
            content:'上限10000条，请选择条件后下载'
          });
        } else {
            this.btnLoading = true
            downloadBusinessList(data).then( res => {
            const fileName = res.headers.filename || 'excel.xls'
            const blob = new Blob([res.data])

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            this.btnLoading = false
          }).catch( err => {
            this.btnLoading = true
            console.log('err')
          })
        }

      })

    },
    findData(searchData){
        this.loading = true;
        this.current = 1;
        this.searchData = searchData
        this.projectFid = this.searchData.projectFid
        this.searchData.page = 1
        this.initTableList()
    },
    refreshData(searchData){
        this.loading = true;
        this.searchData = searchData
        this.projectFid = this.searchData.projectFid
        this.initTableList()
    },
    initData(){
      getProjects().then( res=> {
        this.projectList = res.data
        if(this.projectList && this.projectList.length > 0){
          this.searchData.projectFid = this.projectList[0].value
        }
        if(this.$route.params.projectFid) {
          this.searchData.projectFid = this.$route.params.projectFid;
        }
        getSelectedData().then( res => {
          this.sourceList = res.data.source
          this.channelList = res.data.channel?res.data.channel:[]
          this.gradeList = res.data.grade?res.data.grade:[]
          this.isLookList = res.data.isLook
          this.loseReasonList = res.data.loseReason
          this.clientTypeList = res.data.clientType
          this.allStatusList = deepClone(res.data.status)
          this.statusList = res.data.status
          this.callStatus=res.data.callStatus
          const index = this.statusList.findIndex(item => {
            return item.value == 0
          })
          if(index > -1) {
            this.statusList.splice(index,1)
          }
          const index2 = this.statusList.findIndex(item => {
            return item.value == 5
          })
          if(index2 > -1) {
            const index3 = this.statusList[index2].children.findIndex(item => {
              return item.value == 18
            })
            if (index3 > -1) {
              this.statusList[index2].children.splice(index3, 1)
            }
          }
          this.initTableList()
        })
      })

    },
    // getHouseTypeList(projectFid){
    // },

    // getCountDown(endHandleTime){

    //   let text = ''
    //   let h = 0
    //   let min = 0
    //   let countdown =  new Date(endHandleTime) - new Date()
    //   if(countdown <0 ) {
    //     text = '已超时'
    //   } else {
    //     h = Math.floor(countdown/3600000)
    //     min = Math.floor((countdown % 3600000)/60000)
    //     text = h<=0 ? `${min}min` : `${h}h${min}min`
    //   }
    //   return {text,countdown}
    // },
    initTableList() {
        //格式化时间
        if(typeof this.searchData.createTimeFrom=='object' && this.searchData.createTimeFrom !== null) {
          this.searchData.createTimeFrom = formatDateTime(this.searchData.createTimeFrom)
        }

      if(typeof this.searchData.createTimeTo=='object' && this.searchData.createTimeTo !== null) {
        this.searchData.createTimeTo = formatDateTime(this.searchData.createTimeTo)
      }

      if(typeof this.searchData.businessEndHandleTimeF=='object' && this.searchData.businessEndHandleTimeF !== null) {
        this.searchData.businessEndHandleTimeF = formatDateTime(this.searchData.businessEndHandleTimeF)
      }

      if(typeof this.searchData.businessEndHandleTimeT=='object' && this.searchData.businessEndHandleTimeT !== null) {
        this.searchData.businessEndHandleTimeT = formatDateTime(this.searchData.businessEndHandleTimeT)
      }

      getList(this.searchData).then( res => {
        this.tableList = res.data.rows
        this.total = res.data.total
        this.loading = false
      })
      this.findProjectInfoByProjectId(this.searchData.projectFid)
    },
    selectItem(selection){
      this.selectedBusiness = selection
    },
    showHistory(){
      this.showHistoryKey++
    },
    getRepeat(repeat, customerPhone){
      if (!repeat) return customerPhone
      if(repeat == 1){
        return customerPhone + '(重复商机)'
      }
      return customerPhone
    },
    getStatusStr(code){
      if (!this.allStatusList.length) return ''
      const str = this.allStatusList.find( item => {
        return item.value == code
      }).text
      return str
    },
    getPlatStr(code){
      if (!this.sourceList.length) return ''
      const str = this.sourceList.find( item => {
        return item.value == code
      })
      return str?str.text:''
    },
    getChannelStr(code) {
      if (!this.channelList.length) return ''
      const str = this.channelList.find( item => {
        return item.value == code
      })
      return str?str.text:''
    },
    findProjectInfoByProjectId(projectFid) {
      if(!projectFid){
        return

      }
      const params = {
        "projectFid": projectFid,
      }
      getBaseInfoByProjectId(params).then(res => {
        this.projectCooperationModel = res.data.projectCooperationModel
        this.serviceRate = res.data.ccoServicePriceRate
      })
    },
  }
};
</script>

<style lang="css" scoped>
.btn {
  margin-bottom: 16px;
}

</style>
